import React from 'react';
import PageHeader from '@/portal/components/PageHeader.tsx';
import { Alert } from 'react-bootstrap';

const IndexPage: React.FC = () => {
  return (
    <>
      <PageHeader title="Dashboard" />
      <div className="p-4">
        <Alert variant="info" className="mb-0">
          Nothing to see here yet. There's no dashboard content available. Use
          the navigation bar to explore other areas of the portal.
        </Alert>
      </div>
    </>
  );
};

export default IndexPage;
